/**
 * Route for `android-sdk`. Registered via createRoute; root wires into router.tsx.
 */
/**
 * /android-sdk — top-level entry for the Android SDK config page (W9-43).
 *
 * Parallel to /tracking/android-sdk; the top-level slug gives operators a
 * direct link that doesn't require knowing the tracking sub-tree.
 * Root wires this route into router.tsx; agents never edit router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AndroidSdkPage } from "@/features/android-sdk/AndroidSdkPage";

export const androidSdkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/android-sdk",
	component: () => <AndroidSdkPage />,
});

export default androidSdkRoute;
